import { createRecipeSlug } from "base/utils";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import logo from "../../images/BlogFreeRecipe-drkBkgrd.png";
import PageDivider from "base/PageDivider";
import React, { useMemo, useState } from "react";
import RecipeBadgeDetails from "./RecipeBadgeDetails";
import RecipeCollapsed from "./RecipeCollapsed";
import RecipeDirections from "./RecipeDirections";
import RecipeIngredientLinkCard from "./RecipeIngredientLinkCard";
import RecipeIngredientToolTab from "./RecipeIngredientToolTab";
import RecipeKitchenToolLinkCard from "./RecipeKitchenToolLinkCard";
import RecipeServingInfo from "./RecipeServingInfo";
import RecipeTiming from "./RecipeTiming";

const createRecipeUrl = (recipe) => {
  const slug = createRecipeSlug(recipe);
  return slug ? `/recipes/${slug}` : `/recipeDetails/${recipe?.id}`;
};

const RecipeCard = ({ recipe, amazonLinkStatus }) => {
  const [isCardToggled, setIsCardToggled] = useState(true);
  const [servings, setServings] = useState(recipe.num_of_servings ?? null);
  React.useEffect(() => {
    setServings(recipe.num_of_servings ?? null);
  }, [recipe.id, recipe.num_of_servings]);

  const handleToggle = () => {
    setIsCardToggled(!isCardToggled);
  };

  const mainPicture = useMemo(() => {
    return recipe.main_picture || recipe.additional_pictures?.[0] || logo;
  }, [recipe]);
  const recipeUrl = useMemo(() => {
    return createRecipeUrl(recipe);
  }, [recipe]);

  const onItemNeeded = (e) => {
    let itemLocation = "#" + e.split(" ").pop();
    window.location.href = `${itemLocation}`;
  };

  return (
    <div className="Recipe-Card p1 marg-b-1">
      <>
        {recipe.status == "pending_approval" ? (
          <div className="Pending-Recipe">Pending</div>
        ) : (
          <></>
        )}
        {isCardToggled ? (
          <div className="Row Space-B">
            <RecipeCollapsed recipe={recipe} badges={recipe.badges} />
            <button className="Dark-Gray" onClick={handleToggle}>
              <FontAwesomeIcon icon={faArrowDown} />
            </button>
          </div>
        ) : (
          <div id="top">
            <div className="Row marg-1 Space-B">
              <Link to={recipeUrl}>
                <h2 className="Width-16">{recipe.recipe_name}</h2>
              </Link>
              <button className="Dark-Gray Relative-Pos" onClick={handleToggle}>
                <FontAwesomeIcon icon={faArrowUp} />
              </button>
            </div>

            <div className="Justify-Center">
              <img
                alt={`${recipe.recipe_name} main image`}
                src={mainPicture}
                className="Large-Logo"
              />
            </div>

            <RecipeTiming recipe={recipe} />
            <PageDivider />

            <div className="p1">
              <RecipeServingInfo
                recipe={recipe}
                servings={servings}
                setServings={setServings}
              />
              <RecipeBadgeDetails badges={recipe.badges} />
            </div>
            <PageDivider />

            <RecipeIngredientToolTab
              recipe={recipe}
              itemNeeded={onItemNeeded}
              servings={servings}
            />
            <PageDivider />

            <RecipeDirections recipe={recipe} />
            {amazonLinkStatus && (
              <>
                <PageDivider />
                <section id="Ingredient" className="Linked-Sections">
                  <h4 className="Linked-Titles">Purchase Ingredients</h4>
                  <RecipeIngredientLinkCard ingredients={recipe.ingredients} />
                  <h6 className="Disclaimer-Text">
                    Please note: the ingredients in this section are
                    suggestions, and may not be the exact product used by the
                    recipe's author.
                  </h6>
                </section>
                <PageDivider />
                <section id="Tool" className="Linked-Sections">
                  <h4 className="Linked-Titles">Purchase Kitchen Tools</h4>
                  <RecipeKitchenToolLinkCard
                    kitchenTools={recipe.kitchen_tools}
                  />
                  <h6 className="Disclaimer-Text">
                    Please note: the kitchen tools in this section are
                    suggestions, and may not be the exact product used by the
                    recipe's author.
                  </h6>
                </section>
              </>
            )}
            <a href="#top" className="Row marg-1 Justify-Center Green">
              <h6 className="Small-Font">Top of Recipe</h6>
            </a>
          </div>
        )}{" "}
      </>
    </div>
  );
};

export default RecipeCard;
